import { Box, Typography, Paper, Autocomplete, TextField } from '@mui/material';
import { SignDetectionPanelProps } from './types';
import { useSignDetectionPanel } from './useSignDetectionPanel';
import './SignDetectionPanel.scss';

export const SignDetectionPanel = (props: SignDetectionPanelProps) => {
  const { config, availableHeaders, categories } = props;
  const {
    handleSourceColumnChange,
    handleNegativeCategoryChange,
    handlePositiveCategoryChange,
  } = useSignDetectionPanel(props);

  // Create category options from the categories prop
  const categoryOptions = categories.map(cat => ({
    value: cat.id,
    label: cat.title,
  }));

  // Find selected category labels
  const selectedNegativeCategory = categoryOptions.find(
    opt => opt.value === config.negativeCategory
  );
  const selectedPositiveCategory = categoryOptions.find(
    opt => opt.value === config.positiveCategory
  );

  return (
    <Paper className="signDetectionPanel" variant="outlined">
      <Box className="signDetectionHeader">
        <Typography variant="h6" className="signDetectionTitle">
          Sign Detection
        </Typography>
        <Typography variant="body2" className="signDetectionHelper">
          Optionally detect category from numeric sign. When source column is
          set, negative values map to the negative category and positive values
          to the positive category. Note that precedence is given to standard
          rules defined below.
        </Typography>
      </Box>

      <Box className="signDetectionContent">
        <Box className="signDetectionField">
          <Autocomplete
            size="small"
            options={availableHeaders}
            value={config.sourceColumn || null}
            onChange={(_, value) => handleSourceColumnChange(value)}
            renderInput={params => (
              <TextField
                {...params}
                label="Source Column"
                placeholder="Select column (optional)"
              />
            )}
          />
        </Box>

        <Box className="signDetectionField">
          <Autocomplete
            size="small"
            options={categoryOptions}
            getOptionLabel={option => option.label}
            value={selectedNegativeCategory || null}
            onChange={(_, value) =>
              handleNegativeCategoryChange(value?.value || null)
            }
            disabled={!config.sourceColumn}
            renderInput={params => (
              <TextField
                {...params}
                label="Negative Category"
                placeholder="Select category"
                required={!!config.sourceColumn}
              />
            )}
          />
        </Box>

        <Box className="signDetectionField">
          <Autocomplete
            size="small"
            options={categoryOptions}
            getOptionLabel={option => option.label}
            value={selectedPositiveCategory || null}
            onChange={(_, value) =>
              handlePositiveCategoryChange(value?.value || null)
            }
            disabled={!config.sourceColumn}
            renderInput={params => (
              <TextField
                {...params}
                label="Positive Category"
                placeholder="Select category"
                required={!!config.sourceColumn}
              />
            )}
          />
        </Box>
      </Box>
    </Paper>
  );
};
